import React, { PureComponent } from 'react'
import { Breadcrumb } from 'hljd'
import styles from './style.module.less'
const Item = Breadcrumb.Item
export default class extends PureComponent {
  static defaultProps = {
    header: ''
  }
  render() {
    const {
      header,
      wrapStyle,
      headerStyle,
      contentStyle,
      extra,
      extraStyle,
      children
    } = this.props
    const _header = Array.isArray(header) ? (
      <Breadcrumb>
        {header.map((item, i) => <Item key={i}>{item}</Item>)}
      </Breadcrumb>
    ) : (
      header
    )
    return (
      <div className={styles.router} style={wrapStyle}>
        <header style={headerStyle} className={styles.header}>
          {_header}
          <div className={styles.extra} style={extraStyle}>
            {extra}
          </div>
        </header>
        <div style={contentStyle} className={styles.content}>
          {children}
        </div>
      </div>
    )
  }
}
